import * as React from 'react'

import type ReportsForm from 'modules/employees/lib/forms/Reports'

import ExportEmployeeSelector from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportEmployeeSelector'
import ReferenceDate from 'modules/employees/components/ExportEmployeesModal/ExportFields/ReferenceDate'

interface Props {
  form: ReportsForm
}

const CompanyTimeoffFields = ({ form }: Props) => {
  return (
    <>
      <ExportEmployeeSelector form={form} />
      <ReferenceDate form={form} />
    </>
  )
}

export default CompanyTimeoffFields
